module.exports = __webpack_public_path__ + "img/campaign02.2249861d.jpg";